export default {"src":"/_next/static/media/bar_code.fe4d1d82.svg","height":60,"width":400,"blurWidth":0,"blurHeight":0};